'use client'
import React, {useEffect} from 'react'
import { default as Router } from "next/router";
import Script from "next/script";
import { usePathname, useSearchParams } from "next/navigation";

export const MatomoScript = (props) => {

  const { url, siteId } = props
  const pathname = usePathname()
  const searchParams = useSearchParams()
  
  useEffect(() => {
    if (window && window._paq) {
      window._paq.push(["setCustomUrl", pathname]);
      window._paq.push(["setDocumentTitle", document.title]);
      window._paq.push(["trackPageView"]);
    }
  }, [pathname, searchParams])


  return (
    <>
      {siteId && (
        <Script
          defer
          id="matomo_s"
          dangerouslySetInnerHTML={{
            __html: `
            var _paq = window._paq = window._paq || [];
            /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
            _paq.push(['trackPageView']);
            _paq.push(['enableLinkTracking']);
            (function() {
                var u="${url}";
                _paq.push(['setTrackerUrl', u+'matomo.php']);
                _paq.push(['setSiteId', '${siteId}']);
                var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
                g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
            })();
            `,
          }}
        />

      )}
    </>
  );
};